import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-alerts.png";

export const Route = createFileRoute(
  "/_staff/ids/_layout/_placeholders/alerts",
)({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
